"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
class ToolbarServiceImpl extends api_shared_js_1.ServiceImplBase {
    get serviceName() {
        return "ToolbarService" /* ToolbarService */;
    }
    revertAllAsync() {
        const verb = api_internal_contract_js_1.VerbId.RevertWorkbook;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'revertAllAsync',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    redoAsync() {
        const verb = api_internal_contract_js_1.VerbId.Redo;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'redoAsync',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    undoAsync() {
        const verb = api_internal_contract_js_1.VerbId.Undo;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'undoAsync',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    exportImageAsync() {
        const verb = api_internal_contract_js_1.VerbId.ExportImage;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'exportImageAsync',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    setAutoUpdateAsync(state) {
        const verb = api_internal_contract_js_1.VerbId.SetAutoUpdate;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'setAutoUpdateAsync',
            [api_internal_contract_js_1.ParameterId.State]: state,
        };
        return this.execute(verb, parameters).then(() => {
            return;
        });
    }
    displayDownloadWorkbookDialogAsync() {
        const verb = api_internal_contract_js_1.VerbId.DownloadWorkbook;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'displayDialogAsync(Workbook)',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    displayExportPdfDialogAsync() {
        const verb = api_internal_contract_js_1.VerbId.ExportPdf;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'displayDialogAsync(ExportPDF)',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    displayExportPowerpointDialogAsync() {
        const verb = api_internal_contract_js_1.VerbId.ExportPowerpoint;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'displayDialogAsync(ExportPowerPoint)',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    displayExportDataDialogAsync() {
        const verb = api_internal_contract_js_1.VerbId.ExportData;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'displayDialogAsync(ExportData)',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    displayExportCrosstabDialogAsync() {
        const verb = api_internal_contract_js_1.VerbId.ExportCrosstab;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'displayDialogAsync(ExportCrossTab)',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    displayShareDialogAsync() {
        const verb = api_internal_contract_js_1.VerbId.Share;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'displayDialogAsync(Share)',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
}
exports.ToolbarServiceImpl = ToolbarServiceImpl;
//# sourceMappingURL=ToolbarServiceImpl.js.map